import { AnalyticsStep } from '@atlaskit/adf-schema/steps';
export function getAnalyticsEventsFromTransaction(tr) {
  return tr.steps.filter(step => step instanceof AnalyticsStep).reduce((acc, step) => [...acc, ...step.analyticsEvents], []);
}